"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStudyPlan = void 0;
var react_1 = require("react");
var firebase = __importStar(require("firebase/app"));
var helpers_1 = require("../../helpers");
var FirebaseProvider_1 = require("../../providers/FirebaseProvider");
function arrayMove(arr, oldIndex, newIndex) {
    if (newIndex >= arr.length) {
        var k = newIndex - arr.length;
        while (k) {
            arr.push(undefined);
            k -= 1;
        }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
}
var reducer = function (state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    console.log(action);
    switch (action.type) {
        case 'SET_DAYS':
            return __assign(__assign({}, state), { days: action.days, orderedDayIds: Object.values(action.days)
                    .sort(function (a, b) {
                    return a.date.getTime() - b.date.getTime();
                })
                    .map(function (day) { return day.id; }) });
        case 'SET_ITEMS':
            return __assign(__assign({}, state), { items: action.items });
        case 'SET_ITEM':
            return __assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_a = {}, _a[action.item.id] = action.item, _a)) });
        case 'SET_ITEM_DAY':
            return __assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_b = {}, _b[action.item] = __assign(__assign({}, state.items[action.item]), { parent: action.day, parentType: 'day' }), _b)) });
        case 'SET_ITEM_DONE':
            return __assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_c = {}, _c[action.item] = __assign(__assign({}, state.items[action.item]), { done: action.done, donePreviously: true }), _c)) });
        case 'SET_DAY_ITEMS':
            return __assign(__assign({}, state), { days: __assign(__assign({}, state.days), (_d = {}, _d[action.day] = __assign(__assign({}, state.days[action.day]), { items: action.items }), _d)) });
        case 'ADD_ITEM':
            return __assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_e = {}, _e[action.item.id] = action.item, _e)), days: __assign(__assign({}, state.days), (_f = {}, _f[action.day] = __assign(__assign({}, state.days[action.day]), { items: __spread(state.days[action.day].items, [action.item.id]) }), _f)) });
        case 'DELETE_ITEM':
            return __assign(__assign({}, state), { days: __assign(__assign({}, state.days), (_g = {}, _g[action.item.parent] = __assign(__assign({}, state.days[action.item.parent]), { items: state.days[action.item.parent].items.filter(function (id) { return id !== action.item.id; }) }), _g)) });
        case 'ADD_SUBITEM':
            return __assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_h = {}, _h[action.subitem.id] = action.subitem, _h[action.subitem.parent] = __assign(__assign({}, state.items[action.subitem.parent]), { subItems: __spread(state.items[action.subitem.parent].subItems, [
                        action.subitem.id,
                    ]) }), _h)) });
        case 'DELETE_SUBITEM':
            return __assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_j = {}, _j[action.subitem.parent] = __assign(__assign({}, state.items[action.subitem.parent]), { subItems: state.items[action.subitem.parent].subItems.filter(function (id) { return id !== action.subitem.id; }) }), _j)) });
        case 'UPDATE_ITEM':
            return __assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_k = {}, _k[action.item] = __assign(__assign({}, state.items[action.item]), action.data), _k)) });
        case 'SET_DRAFT_STATUS':
            return __assign(__assign({}, state), { isDraft: action.isDraft });
        case 'SET_START_DATE':
            return __assign(__assign({}, state), { startDate: action.date });
        case 'SET_TEST_DATE':
            return __assign(__assign({}, state), { testDate: action.date });
        case 'SET_WEEK_START':
            return __assign(__assign({}, state), { startWeekOn: action.day });
        case 'SET_CATEGORIES':
            return __assign(__assign({}, state), { categories: action.categories });
        case 'SET_HAS_PLAN':
            return __assign(__assign({}, state), { hasPlan: action.hasPlan });
        case 'SET_LOADING_PLAN':
            return __assign(__assign({}, state), { loadingPlan: action.loading });
        case 'SET_TITLE':
            return __assign(__assign({}, state), { title: action.title });
        case 'SET_DESCRIPTION':
            return __assign(__assign({}, state), { description: action.description });
        case 'SET_PUBLISHED':
            return __assign(__assign({}, state), { published: action.published });
        default:
            return state;
    }
};
exports.useStudyPlan = function (userId) {
    var db = FirebaseProvider_1.useFirebase().db;
    var _a = __read(react_1.useState(true), 2), loadingDays = _a[0], setLoadingDays = _a[1];
    var _b = __read(react_1.useState(true), 2), loadingItems = _b[0], setLoadingItems = _b[1];
    var _c = __read(react_1.useReducer(reducer, {
        startDate: new Date(),
        testDate: new Date(),
        startWeekOn: 0,
        isDraft: false,
        items: {},
        days: {},
        orderedDayIds: [],
        categories: [],
        hasPlan: false,
        loadingPlan: true,
        title: '',
        description: '',
        published: false,
    }), 2), state = _c[0], dispatch = _c[1];
    var days = state.days, items = state.items, isDraft = state.isDraft, loadingPlan = state.loadingPlan;
    var studyPlanRef = db
        .collection('users')
        .doc(userId || 'uid')
        .collection('study-plan')
        .doc('plan');
    var itemsRef = studyPlanRef.collection('items');
    var daysRef = studyPlanRef.collection('days');
    react_1.useEffect(function () {
        if (userId) {
            db.collection('users')
                .doc(userId)
                .collection('study-plan')
                .doc('plan')
                .onSnapshot(function (doc) {
                if (doc.exists) {
                    var data = doc.data();
                    dispatch({
                        type: 'SET_DRAFT_STATUS',
                        isDraft: false,
                    });
                    dispatch({
                        type: 'SET_START_DATE',
                        date: helpers_1.toDate(data.startDate),
                    });
                    dispatch({
                        type: 'SET_TEST_DATE',
                        date: helpers_1.toDate(data.endDate),
                    });
                    dispatch({
                        type: 'SET_WEEK_START',
                        day: data.startWeekOn,
                    });
                    dispatch({
                        type: 'SET_CATEGORIES',
                        categories: data.categories,
                    });
                    dispatch({
                        type: 'SET_HAS_PLAN',
                        hasPlan: true,
                    });
                    dispatch({
                        type: 'SET_TITLE',
                        title: data.title || '',
                    });
                    dispatch({
                        type: 'SET_DESCRIPTION',
                        description: data.description || '',
                    });
                    dispatch({
                        type: 'SET_PUBLISHED',
                        published: data.published || false,
                    });
                }
                dispatch({
                    type: 'SET_LOADING_PLAN',
                    loading: false,
                });
            });
            var daysQuery = db
                .collection('users')
                .doc(userId)
                .collection('study-plan')
                .doc('plan')
                .collection('days');
            daysQuery.get().then(function (snapshot) {
                if (snapshot.docs.length) {
                    var dayDocs = snapshot.docs.map(function (doc) {
                        return (__assign(__assign({}, doc.data()), { id: doc.id, date: helpers_1.toDate(doc.data().date) }));
                    });
                    dispatch({
                        type: 'SET_DAYS',
                        days: dayDocs.reduce(function (map, day) {
                            var _a;
                            return __assign(__assign({}, map), (_a = {}, _a[day.id] = day, _a));
                        }, {}),
                    });
                }
                setLoadingDays(false);
            });
            var itemsQuery = db
                .collection('users')
                .doc(userId)
                .collection('study-plan')
                .doc('plan')
                .collection('items');
            itemsQuery.get().then(function (snapshot) {
                var itemDocs = [];
                if (snapshot.docs.length) {
                    snapshot.forEach(function (doc) {
                        itemDocs.push(__assign(__assign({}, doc.data()), { id: doc.id, createdAt: helpers_1.toDate(doc.data().createdAt), date: helpers_1.toDate(doc.data().date) }));
                    });
                    dispatch({
                        type: 'SET_ITEMS',
                        items: itemDocs.reduce(function (map, item) {
                            var _a;
                            return __assign(__assign({}, map), (_a = {}, _a[item.id] = item, _a));
                        }, {}),
                    });
                }
                setLoadingItems(false);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);
    var createPlan = react_1.useCallback(function (customUserId) { return __awaiter(void 0, void 0, void 0, function () {
        var planRef, promises, remainingDays, _loop_1, remainingitems, _loop_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    planRef = db
                        .collection('users')
                        .doc(customUserId || userId)
                        .collection('study-plan')
                        .doc('plan');
                    promises = [
                        db
                            .collection('users')
                            .doc(customUserId || userId)
                            .update({ hasStudyPlan: true }),
                        planRef.set({
                            startDate: state.startDate,
                            testDate: state.testDate,
                            startWeekOn: state.startWeekOn,
                            categories: state.categories,
                        }),
                    ];
                    remainingDays = Object.values(days);
                    _loop_1 = function () {
                        var batch = db.batch();
                        var batchDays = remainingDays.slice(0, 500);
                        remainingDays = remainingDays.slice(500);
                        batchDays.forEach(function (day) {
                            batch.set(planRef.collection('days').doc(day.id), day);
                        });
                        promises.push(batch.commit());
                    };
                    while (remainingDays.length > 0) {
                        _loop_1();
                    }
                    remainingitems = Object.values(items);
                    _loop_2 = function () {
                        var batch = db.batch();
                        var batchitems = remainingitems.slice(0, 500);
                        remainingitems = remainingitems.slice(500);
                        batchitems.forEach(function (item) {
                            batch.set(planRef.collection('items').doc(item.id), item);
                        });
                        promises.push(batch.commit());
                    };
                    while (remainingitems.length > 0) {
                        _loop_2();
                    }
                    return [4 /*yield*/, Promise.all(promises)];
                case 1:
                    _a.sent();
                    dispatch({ type: 'SET_DRAFT_STATUS', isDraft: false });
                    dispatch({ type: 'SET_HAS_PLAN', hasPlan: true });
                    setLoadingDays(false);
                    setLoadingItems(false);
                    return [2 /*return*/];
            }
        });
    }); }, [
        days,
        db,
        state.categories,
        state.startDate,
        state.startWeekOn,
        state.testDate,
        items,
        userId,
    ]);
    var addItem = react_1.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var promises, id, item, dayId, dayDoc, day;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    promises = [];
                    id = itemsRef.doc().id;
                    item = {
                        id: id,
                        createdAt: new Date(),
                        title: data.title,
                        date: data.date,
                        parent: data.type === 'subitem' ? data.parent : data.day,
                        parentType: data.type === 'subitem' ? 'item' : 'day',
                        subItems: [],
                        done: false,
                    };
                    if (!(data.type === 'item')) return [3 /*break*/, 4];
                    dayId = data.day;
                    dayDoc = daysRef.doc();
                    day = state.days[dayId] || {
                        createdAt: new Date(),
                        id: dayDoc.id,
                        date: data.date,
                        items: [],
                    };
                    if (dayId === 'new-day') {
                        dayId = dayDoc.id;
                        dispatch({
                            type: 'SET_DAYS',
                            days: __assign(__assign({}, state.days), (_a = {}, _a[dayId] = day, _a)),
                        });
                    }
                    dispatch({
                        type: 'ADD_ITEM',
                        day: dayId,
                        item: item,
                    });
                    if (!!isDraft) return [3 /*break*/, 3];
                    if (!(data.day === 'new-day')) return [3 /*break*/, 2];
                    return [4 /*yield*/, daysRef.doc(dayId).set(day)];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    promises.push(daysRef.doc(dayId).update({
                        items: firebase.firestore.FieldValue.arrayUnion(id),
                    }));
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    if (!data.parent) {
                        throw new Error('Parent ID is required for subitem.');
                    }
                    item = __assign(__assign({}, item), { parent: data.parent });
                    dispatch({ type: 'ADD_SUBITEM', subitem: item });
                    if (!isDraft) {
                        // Add to parent item
                        itemsRef
                            .doc(data.parent)
                            .update({ subItems: firebase.firestore.FieldValue.arrayUnion(id) });
                    }
                    _b.label = 5;
                case 5:
                    if (!isDraft) {
                        promises.push(itemsRef.doc(id).set(item));
                    }
                    return [2 /*return*/, Promise.all(promises)];
            }
        });
    }); }, [daysRef, isDraft, itemsRef, state.days]);
    var updateItem = react_1.useCallback(function (itemId, data) {
        dispatch({ type: 'UPDATE_ITEM', data: data, item: itemId });
        if (!isDraft) {
            itemsRef.doc(itemId).update(data);
        }
    }, [isDraft, itemsRef]);
    var toggleItemDone = react_1.useCallback(function (item) {
        dispatch({ type: 'SET_ITEM_DONE', item: item.id, done: !item.done });
        if (!isDraft) {
            itemsRef
                .doc(item.id)
                .update({ done: !item.done, donePreviously: true });
        }
    }, [isDraft, itemsRef]);
    var moveItem = react_1.useCallback(function (item, source, target) {
        var promises = [];
        var sourceDay;
        var targetDay;
        if (source.type === 'day') {
            sourceDay = days[source.id];
        }
        if (target.type === 'day') {
            targetDay = days[target.id];
        }
        if (sourceDay && targetDay && sourceDay.id !== targetDay.id) {
            // Item has been moved to another day.
            // Remove from source day and add to target day.
            if (!isDraft) {
                promises.push(daysRef.doc(sourceDay.id).update({
                    items: firebase.firestore.FieldValue.arrayRemove(item),
                }));
            }
            dispatch({
                type: 'SET_DAY_ITEMS',
                day: sourceDay.id,
                items: sourceDay.items.filter(function (id) { return id !== item; }),
            });
            var newitems = __spread(targetDay.items);
            newitems.splice(target.index, 0, item);
            dispatch({
                type: 'SET_DAY_ITEMS',
                day: targetDay.id,
                items: newitems,
            });
            dispatch({
                type: 'SET_ITEM_DAY',
                day: targetDay.id,
                item: item,
            });
            if (!isDraft) {
                promises.push(daysRef.doc(targetDay.id).update({
                    items: newitems,
                }));
                promises.push(updateItem(item, { parent: targetDay.id }));
            }
        }
        if (sourceDay && targetDay && sourceDay.id === targetDay.id) {
            // Item has been re-positioned within the same day.
            var newitems = __spread(targetDay.items);
            newitems = arrayMove(newitems, source.index, target.index);
            dispatch({
                type: 'SET_DAY_ITEMS',
                day: targetDay.id,
                items: newitems,
            });
            if (!isDraft) {
                promises.push(daysRef.doc(targetDay.id).update({
                    items: newitems,
                }));
            }
        }
    }, [days, daysRef, isDraft, updateItem]);
    var deleteItem = react_1.useCallback(function (item) {
        var promises = [];
        if (!isDraft) {
            item.subItems.forEach(function (subitem) {
                promises.push(itemsRef.doc(subitem).delete());
            });
        }
        if (item.parentType === 'day') {
            dispatch({ type: 'DELETE_ITEM', item: item });
            promises.push(daysRef.doc(item.parent).update({
                items: firebase.firestore.FieldValue.arrayRemove(item.id),
            }));
        }
        else {
            dispatch({ type: 'DELETE_SUBITEM', subitem: item });
            if (!isDraft) {
                promises.push(itemsRef.doc(item.parent).update({
                    subItems: firebase.firestore.FieldValue.arrayRemove(item.id),
                }));
            }
        }
        if (!isDraft) {
            promises.push(itemsRef.doc(item.id).delete());
        }
    }, [daysRef, isDraft, itemsRef]);
    var setDraftPlan = react_1.useCallback(function (plan) {
        dispatch({
            type: 'SET_DAYS',
            days: plan.days.reduce(function (map, day) {
                var _a;
                return __assign(__assign({}, map), (_a = {}, _a[day.id] = day, _a));
            }, {}),
        });
        dispatch({
            type: 'SET_ITEMS',
            items: plan.items.reduce(function (map, item) {
                var _a;
                return __assign(__assign({}, map), (_a = {}, _a[item.id] = item, _a));
            }, {}),
        });
        dispatch({
            type: 'SET_DRAFT_STATUS',
            isDraft: true,
        });
        dispatch({
            type: 'SET_START_DATE',
            date: plan.startDate,
        });
        dispatch({
            type: 'SET_TEST_DATE',
            date: plan.endDate,
        });
        dispatch({
            type: 'SET_WEEK_START',
            day: plan.startWeekOn,
        });
        dispatch({
            type: 'SET_CATEGORIES',
            categories: plan.categories,
        });
    }, []);
    var setPlan = react_1.useCallback(function (days, items) {
        dispatch({
            type: 'SET_DAYS',
            days: days.reduce(function (map, day) {
                var _a;
                return __assign(__assign({}, map), (_a = {}, _a[day.id] = day, _a));
            }, {}),
        });
        dispatch({
            type: 'SET_ITEMS',
            items: items.reduce(function (map, item) {
                var _a;
                return __assign(__assign({}, map), (_a = {}, _a[item.id] = item, _a));
            }, {}),
        });
        setLoadingDays(false);
        setLoadingItems(false);
    }, []);
    var deletePlan = react_1.useCallback(function () {
        dispatch({ type: 'SET_HAS_PLAN', hasPlan: false });
        var remainingitems = Object.values(items);
        var remainingDays = Object.values(days);
        var promises = [
            db.collection('users').doc(userId).update({ hasStudyPlan: false }),
            db
                .collection('users')
                .doc(userId)
                .collection('study-plan')
                .doc('plan')
                .delete(),
        ];
        var _loop_3 = function () {
            var batch = db.batch();
            var batchitems = remainingitems.slice(0, 500);
            remainingitems = remainingitems.slice(500);
            batchitems.forEach(function (item) {
                batch.delete(itemsRef.doc(item.id));
            });
            promises.push(batch.commit());
        };
        while (remainingitems.length > 0) {
            _loop_3();
        }
        var _loop_4 = function () {
            var batch = db.batch();
            var batchDays = remainingDays.slice(0, 500);
            remainingDays = remainingDays.slice(500);
            batchDays.forEach(function (day) {
                batch.delete(daysRef.doc(day.id));
            });
            promises.push(batch.commit());
        };
        while (remainingDays.length > 0) {
            _loop_4();
        }
        return Promise.all(promises);
    }, [days, daysRef, db, items, itemsRef, userId]);
    var setStartDate = react_1.useCallback(function (date) {
        dispatch({ type: 'SET_START_DATE', date: date });
    }, []);
    var setTestDate = react_1.useCallback(function (date) {
        dispatch({ type: 'SET_TEST_DATE', date: date });
    }, []);
    var setStartWeekOn = react_1.useCallback(function (day) {
        dispatch({ type: 'SET_WEEK_START', day: day });
    }, []);
    var setTitle = react_1.useCallback(function (title) {
        dispatch({ type: 'SET_TITLE', title: title });
    }, []);
    var setDescription = react_1.useCallback(function (description) {
        dispatch({ type: 'SET_DESCRIPTION', description: description });
    }, []);
    var publish = react_1.useCallback(function () {
        dispatch({ type: 'SET_PUBLISHED', published: true });
        studyPlanRef.update({
            published: true,
            title: state.title,
            description: state.description,
        });
    }, [state.description, state.title, studyPlanRef]);
    return __assign(__assign({}, state), { title: state.title || "My " + state.orderedDayIds.length + " day study plan", addItem: addItem,
        createPlan: createPlan,
        deletePlan: deletePlan,
        deleteItem: deleteItem, loading: loadingPlan || loadingDays || loadingItems, moveItem: moveItem,
        setPlan: setPlan,
        setDraftPlan: setDraftPlan,
        toggleItemDone: toggleItemDone,
        updateItem: updateItem,
        setStartDate: setStartDate,
        setTestDate: setTestDate,
        setStartWeekOn: setStartWeekOn,
        setTitle: setTitle,
        setDescription: setDescription,
        publish: publish });
};
exports.default = exports.useStudyPlan;
//# sourceMappingURL=useStudyPlan.js.map